package one.healthium.insights.domain.models

data class ContentScreenModel(
    val id: String?,
    val navbar: NavbarModel?,
    val preview: ContentPreviewModel?,
    val content: List<ContentEntry>,
)
